import { Product } from "@/types/types.ts";
import { DMS_IDS } from "@/constants/constants";

export const isTwoManDelivery = (product: Product) => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some(
    (option) => option.aliases.dmsId === DMS_IDS.TwoPersonDelivery,
  );
};
